import { render } from "./CallLog.vue?vue&type=template&id=4d0c8a1a"
import script from "./CallLog.vue?vue&type=script&lang=js"
export * from "./CallLog.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__